var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        !_vm.pageReady
          ? _c("div", { staticClass: "container" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _vm.pageReady
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "watermark",
                    domProps: { innerHTML: _vm._s(_vm.data.misc.watermark) }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "consent-text",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consent.consentText)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix--min" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group btn-group-toggle btn-block" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "btn btn-primary btn-consent btn-lg",
                          class: _vm.consentUsage === true ? "active" : "",
                          attrs: { id: "consentUsage" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.consentUsage,
                                expression: "consentUsage"
                              }
                            ],
                            attrs: { type: "checkbox", autocomplete: "off" },
                            domProps: {
                              value: true,
                              checked: Array.isArray(_vm.consentUsage)
                                ? _vm._i(_vm.consentUsage, true) > -1
                                : _vm.consentUsage
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.consentUsage,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = true,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.consentUsage = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.consentUsage = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.consentUsage = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.data.misc.consentApproveBtn) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass:
                      "btn btn-consent btn-secondary btn-lg btn-block",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#decline-approval"
                    },
                    domProps: { innerHTML: _vm._s(_vm.data.misc.noThanksBtn) }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("small", {
                    staticClass: "text-muted",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consent.consentDisclaimer)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "consent-text",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consent.consentResearchText)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix--min" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group btn-group-toggle btn-block" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "btn btn-outline-secondary btn-lg",
                          class: _vm.consentResearch === true ? "active" : ""
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.consentResearch,
                                expression: "consentResearch"
                              }
                            ],
                            attrs: { type: "radio", autocomplete: "off" },
                            domProps: {
                              value: true,
                              checked: _vm._q(_vm.consentResearch, true)
                            },
                            on: {
                              change: function($event) {
                                _vm.consentResearch = true
                              }
                            }
                          }),
                          _vm._v("Ja\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "btn btn-outline-secondary btn-lg",
                          class: _vm.consentResearch === false ? "active" : ""
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.consentResearch,
                                expression: "consentResearch"
                              }
                            ],
                            attrs: { type: "radio", autocomplete: "off" },
                            domProps: {
                              value: false,
                              checked: _vm._q(_vm.consentResearch, false)
                            },
                            on: {
                              change: function($event) {
                                _vm.consentResearch = false
                              }
                            }
                          }),
                          _vm._v("Nej\n          ")
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-give-consent btn-lg btn-block",
                      attrs: {
                        disabled:
                          !_vm.consentUsage || _vm.consentResearch === null
                      },
                      on: {
                        click: function($event) {
                          return _vm.giveConsent()
                        }
                      }
                    },
                    [_vm._v("\n          Gå vidare\n        ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm" })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: { id: "decline-approval", role: "dialog", tabindex: "-1" }
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("×")]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consent.declineApprovalModal)
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-consent btn-primary btn-lg btn-block",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass:
                      "btn btn-consent btn-secondary btn-lg btn-block",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.misc.consentDeclineBtn)
                    },
                    on: {
                      click: function($event) {
                        return _vm.declineApproval()
                      }
                    }
                  })
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", {
        staticClass: "progress-bar",
        staticStyle: { width: "33%" },
        attrs: {
          role: "progressbar",
          "aria-valuenow": "33",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ca551a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ca551a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Consent.vue
// module id = null
// module chunks = 